import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputMask from "react-input-mask";
import { DatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import ruLocale from "date-fns/locale/ru";
import { CircularProgress, Grid, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGeoObjects } from "../../../redux/actions/geoObjectActions";
import { getEmployees } from "../../../redux/actions/employeeActions";
import { getBrigadeTypes } from "../../../redux/actions/brigadeTypeActions";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function CreateBrigade({ action, title, open, setOpen, onSubmit }) {
    const dispatch = useDispatch();
    const [id, setId] = useState(null);
    const [number, setNumber] = useState('');
    const [createdAt, setCreatedAt] = useState(new Date());
    const [addressLine, setAddressLine] = useState('');
    const [addressId, setAddressId] = useState(null);
    const [disinfectorId, setDisinfectorId] = useState(null);
    const [typeId, setTypeId] = useState(null);
    const { loading, brigades, brigade } = useSelector((state) => state.brigade);
    const { geoObjects, geoObjectRequestedCount } = useSelector((state) => state.geoObject);
    const { employees, employeeRequestedCount } = useSelector((state) => state.employee);
    const { brigadeTypes, brigadeTypeRequestedCount } = useSelector((state) => state.brigadeType);
    const emptyState = () => {
        setId(null);
        setNumber('');
        setCreatedAt(new Date());
        setAddressLine('');
        setAddressId(null);
        setDisinfectorId(null);
        setTypeId(null);
    };
    const handleForm = async (e) => {
        e.preventDefault();
        onSubmit({ id, number, createdAt, addressLine, addressId, disinfectorId, typeId });
        setOpen(false);
        emptyState();
    };
    const handleClose = async () => {
        setOpen(false);
        emptyState();
    };
    useEffect(() => {
        const {
            id, number, createdAt, addressLine, addressId, disinfectorId, typeId
        } = brigade || {};
        setId(id);
        setNumber(number);
        setCreatedAt(createdAt);
        setAddressLine(addressLine);
        setAddressId(addressId);
        setDisinfectorId(disinfectorId);
        setTypeId(typeId);
    }, [brigade, brigades])
    useEffect(() => {
        if (!open)
        {
            return;
        }
        let response;
        const getGeoObjectsAsync = async () => {
            response = await dispatch(getGeoObjects({ paging: { skip: 0, take: 10 } }));
        }
        const getEmployeesAsync = async () => {
            response = await dispatch(getEmployees({ paging: { skip: 0, take: 10 } }));
        }
        const getBrigadeTypesAsync = async () => {
            response = await dispatch(getBrigadeTypes({ paging: { skip: 0, take: 10 } }));
        }
        if (geoObjectRequestedCount == 0)
        {
            getGeoObjectsAsync();
        }
        if (employeeRequestedCount == 0)
        {
            getEmployeesAsync();
        }
        if (brigadeTypeRequestedCount == 0)
        {
            getBrigadeTypesAsync();
        }
    }, [dispatch, action, open])
    return (
        <div>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {loading ? <CircularProgress/> :
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {title}
                        </Typography>
                        <Box component="form" onSubmit={handleForm} sx={{mt: 1, display: 'flex', flexWrap: 'wrap'}}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <TextField margin="normal" required value={number} onChange={(e) => setNumber(e.target.value)} fullWidth id="number" name="number" label="Номер" />
                                </Grid>
                                <Grid item xs={6}>
                                    <LocalizationProvider locale={ruLocale} dateAdapter={AdapterDateFns}>
                                        <DatePicker views={['day']} label="Создано" value={createdAt} onChange={(newValue) => {
                                            setCreatedAt(newValue);
                                        }}  renderInput={(params) =>
                                            <TextField margin="normal"  {...params} helperText={null}/>
                                        }/>
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField margin="normal"  value={addressLine} onChange={(e) => setAddressLine(e.target.value)} fullWidth id="addressLine" name="addressLine" label="Адрес" />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField  value={addressId} onChange={(e) => setAddressId(e.target.value)} margin="normal" fullWidth id="addressId" select>
                                        {geoObjects && geoObjects.map(_ => (
                                            <MenuItem key={_.id} value={_.id}>
                                                {_.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField  value={disinfectorId} onChange={(e) => setDisinfectorId(e.target.value)} margin="normal" fullWidth id="disinfectorId" select>
                                        {employees && employees.map(_ => (
                                            <MenuItem key={_.id} value={_.id}>
                                                {_.fullName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField  value={typeId} onChange={(e) => setTypeId(e.target.value)} margin="normal" fullWidth id="typeId" select>
                                        {brigadeTypes && brigadeTypes.map(_ => (
                                            <MenuItem key={_.id} value={_.id}>
                                                {_.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                {action != 'details' && 
                                    <Grid item xs={6}>
                                        <Button type="submit" fullWidth variant="contained" sx={{mt: 3, mb: 2}}>
                                            {'Сохранить'}
                                        </Button>
                                    </Grid>
                                }
                            </Grid>
                        </Box>
                    </Box>
                }
            </Modal>
        </div>
    )
}
